import { render, staticRenderFns } from "./WorkspaceSurveyManagement.vue?vue&type=template&id=a4107476&"
import script from "./WorkspaceSurveyManagement.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSurveyManagement.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSurveyManagement.vue?vue&type=style&index=0&id=a4107476&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports